import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { CategoriesService } from '../shared/category/categories.service';
import { IndirectJobsService } from './indirect-jobs.service';
import { IndirectJobsFeaturesComponent } from './features/indirect-jobs-features.component';
import { processResolver } from '../efaact-routing/process-resolver';

const log = new LoggingService();
export const IndirectJobsRoute: Ng2StateDeclaration = {
    name: 'indirectjobs',
    url: '/indirectjobs',
    data: { requiresAuth: true },
    params: { process: {} },
    resolve: [
        {
            token: 'process',
            deps: [Transition, CategoriesService],
            resolveFn: processResolver
        }
    ],
    component: IndirectJobsFeaturesComponent
};
